/* global window */
import React from 'react'
import ReactDOM from 'react-dom'
import { ProductPanel } from '@sainsburys-tech/bolt'
import * as Styled from './CreditOptionProductContent.styles'

import FableAddToTrolleyButton from '@/javascript/components/FableAddToTrolleyButton/FableAddToTrolleyButton'
import { onCreditOptionsSlidingPanelOpen, onAddToTrolleyModalOpen } from '../../credit-options.tracking'

export default class CreditOptionsProductContent extends React.Component {
  componentDidUpdate(prevProps) {
    const { product } = this.props
    if (prevProps.product !== product || prevProps.product === product) {
      if (product) {
        const price = product.included.find(item => item.type === 'prices')?.attributes
        onCreditOptionsSlidingPanelOpen(
          { id: product.data.id, price: price.now },
          {
            type: 'quickview',
            clickOrigin: 'PDP:creditQuickviewLb'
          },
          window
        )
      }
    }
  }

  clickAddToTrolley = () => {
    const { toggleCreditOptions, product } = this.props
    const price = product.included.find(item => item.type === 'prices')?.attributes

    onAddToTrolleyModalOpen(
      { id: product.data.id, price: price.now },
      {
        clickOrigin: 'PDP:creditLb:ATT'
      },
      window
    )
    toggleCreditOptions()
  }

  render() {
    const { product, footerPortal, isLoading, dataTest } = this.props

    if (isLoading) return <ProductPanel.ProductPanelSkeleton />

    if (!product || !Object.keys(product)?.length) {
      return null
    }

    const { partNumber, name } = product.data.attributes
    const price = product.included.find(item => item.type === 'prices')?.attributes

    const reviews = product.included.find(included => included.type === 'reviewstatistics').attributes
    return (
      <div>
        <ProductPanel
          partNumber={partNumber}
          name={name}
          price={price.now}
          wasPrice={price.was}
          flashText={price.flashText}
          rating={reviews.avgRating}
          ratingCount={reviews.reviewCount}
          data-test={`${dataTest}-product-panel`}
        />

        {footerPortal &&
          ReactDOM.createPortal(
            <>
              <Styled.CTAButton
                forwardedAs='a'
                kind='secondary'
                target='_blank'
                type='Argos Card Application'
                href='https://www.argos.co.uk/credit-application/choice'
                full
              >
                Apply Now
              </Styled.CTAButton>
              <FableAddToTrolleyButton
                productId={product?.data?.id}
                full
                onClick={this.clickAddToTrolley}
                data-test={`${dataTest}-att`}
                quantity={1}
              />
            </>,
            window.document.querySelector(`#${footerPortal}`)
          )}
      </div>
    )
  }
}
